(() => {
  const base = window.Shopify?.routes?.root || '/';
  const giftCode = 'ABEL-BURNER-AND-OIL';
  let busy = false;
  const message = key => JSON.parse(document.querySelector('[data-component-strings]').textContent)[key];
  async function request(path, body) {
    // A unique URL also avoids cached cart snapshots held by storefront scripts.
    const url = base + path + (body === undefined ? '?_abel_cart=' + crypto.randomUUID() : '');
    const response = await fetch(url, {
      method: body === undefined ? 'GET' : 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      cache: 'no-store',
      body: body === undefined ? undefined : JSON.stringify(body)
    });
    const value = await response.json();
    if (!response.ok) throw Error(value.description || message('check_bag'));
    return value;
  }
  function codes(cart) {
    const allocations = (cart.items || []).flatMap(item => item.line_level_discount_allocations || []);
    return [...new Set([
      ...(cart.discount_codes || []).map(item => item.code),
      ...(cart.cart_level_discount_applications || []).filter(item => item.type === 'discount_code').map(item => item.title),
      ...allocations.filter(item => item.discount_application?.type === 'discount_code').map(item => item.discount_application.title)
    ].filter(Boolean))];
  }
  const giftItems = (cart, group) => cart.items.filter(item => item.properties?._abel_gift_group === group);
  const pause = () => new Promise(resolve => setTimeout(resolve, 250));
  function confirmed(cart, before, entries, group, expectedTotal) {
    const wanted = new Map();
    for (const entry of entries) {
      const id = String(entry.variant.id);
      wanted.set(id, (wanted.get(id) || 0) + 1);
    }
    for (const item of giftItems(cart, group)) {
      const id = String(item.variant_id || item.id);
      if (!wanted.has(id)) return false;
      wanted.set(id, wanted.get(id) - item.quantity);
    }
    // Use the net basket increase because Shopify can allocate the saving to
    // another eligible oil already in the bag. Never accept a higher charge.
    return [...wanted.values()].every(quantity => quantity === 0)
      && Number.isFinite(cart.total_price) && Number.isFinite(before.total_price)
      && cart.total_price - before.total_price <= expectedTotal;
  }
  async function rollback(group, previousCodes, restoreCodes) {
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const cart = await request('cart.js');
        const updates = Object.fromEntries(giftItems(cart, group).map(item => [item.key, 0]));
        // Remove the entire attempted gift together. Removing one discounted
        // line at a time changes the remaining line keys as discounts recalculate.
        if (Object.keys(updates).length || restoreCodes) {
          await request('cart/update.js', {
            updates,
            ...(restoreCodes ? { discount: previousCodes.join(',') } : {})
          });
        }
        const after = await request('cart.js');
        if (!giftItems(after, group).length) return;
      } catch (error) {
        if (attempt === 2) throw error;
      }
      await pause();
    }
    throw Error(message('partial'));
  }
  window.AbelGiftCart = {
    async add(entries, expectedTotal, useGiftSaving, giftName) {
      if (busy) throw Error(message('wait'));
      busy = true;
      const group = crypto.randomUUID();
      let attempted = false;
      let discountAttempted = false;
      let previousCodes = [];
      try {
        const before = await request('cart.js');
        previousCodes = codes(before);
        attempted = true;
        await request('cart/add.js', { items: entries.map(entry => ({
          id: entry.variant.id,
          quantity: 1,
          properties: { _abel_gift_group: group, 'Gift selection': giftName }
        })) });
        if (useGiftSaving) {
          discountAttempted = true;
          await request('cart/update.js', { discount: [...new Set([...previousCodes, giftCode])].join(',') });
        }
        // Confirm the committed cart, not an intermediate discount response.
        // Retry reads only: repeating an add would duplicate the customer's gift.
        for (let attempt = 0; attempt < 3; attempt++) {
          const cart = await request('cart.js');
          if (confirmed(cart, before, entries, group, expectedTotal)) return cart;
          if (attempt < 2) await pause();
        }
        throw Error(message('price_unconfirmed'));
      } catch (error) {
        if (attempted) {
          try {
            await rollback(group, previousCodes, discountAttempted);
          } catch {
            throw Error(message('partial'));
          }
        }
        throw error;
      } finally {
        busy = false;
      }
    }
  };
})();
